import ModuleContent from 'features/shared/layout/content/ModuleContent';
import SimpleLayout from 'features/shared/layout/SimpleLayout';
import React from 'react';
import CustomerAccountRegistrationSection from './sections/CustomerAccountRegistrationSection';

const CustomerAccountRegistration = () => {
  return (
    <SimpleLayout useSpinner>
      <ModuleContent>
        <CustomerAccountRegistrationSection />
      </ModuleContent>
    </SimpleLayout>
  );
};

export default CustomerAccountRegistration;
